import axios from "axios";
import {config} from "../constants";
import authHeader from "./auth-header";
import CommonService from "./common.service";

class ReportService {

    search(type, startDate, endDate, searchFilter, onlyFound) {
        return axios.post(
            config.API_URL + "report/search",
            {
                type: type,
                startDate: startDate,
                endDate: endDate,
                searchFilter: searchFilter,
                onlyFound: onlyFound,
                lang: CommonService.getLang()
            },
            {headers: authHeader()}
        );
    }

    excelMonthlyReport(startDate) {
        return axios.post(
            config.API_URL + "report/monthly-excel",
            {
                excelReportDate: startDate,
                lang: CommonService.getLang()
            },
            {
                headers: authHeader(),
                responseType: 'blob'
            },
        );
    }

    searchDetail(itemId) {
        return axios.get(config.API_URL + "report/search-detail/" + itemId + "/" + CommonService.getLang(), {headers: authHeader()});
    }

    summary() {
        return axios.get(config.API_URL + "report/summary", {headers: authHeader()});
    }

    downloadPDF(itemId) {
        return axios.get(config.API_URL + "report/download-pdf/" + itemId + "/" + CommonService.getLang(), {headers: authHeader(), responseType: "blob"});
    }

    saveSearchId(searchId) {
        localStorage.setItem("searchId", searchId)
    }

    getSearchId() {
        const searchId = localStorage.getItem("searchId");

        if (!searchId) {
            return ""
        }

        this.removeSearchId();

        return searchId;
    }

    removeSearchId() {
        localStorage.removeItem("searchId")
    }

}

export default new ReportService();
